var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-form",
    {
      ref: "detailForm",
      attrs: {
        model: _vm.detail,
        "label-width": "100px",
        "label-position": _vm.device === "mobile" ? "top" : "right",
      },
    },
    [
      _c(
        "el-collapse",
        {
          staticClass: "el-card-collapse",
          model: {
            value: _vm.activeCollapses,
            callback: function ($$v) {
              _vm.activeCollapses = $$v
            },
            expression: "activeCollapses",
          },
        },
        [
          _c(
            "el-collapse-item",
            { attrs: { title: "基本信息", name: "Basic" } },
            [
              _c(
                "el-row",
                { attrs: { gutter: 20 } },
                [
                  _c(
                    "el-col",
                    { attrs: { xs: 24, sm: 16 } },
                    [
                      _c("el-form-item", { attrs: { label: "商品名称" } }, [
                        _c("span", { staticClass: "el-input" }, [
                          _vm._v(_vm._s(_vm.detail.goodsName)),
                        ]),
                      ]),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { xs: 24, sm: 8 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          staticClass: "inline-form-item",
                          attrs: { label: "商品单位" },
                        },
                        [
                          _c("span", { staticClass: "el-input max-width" }, [
                            _vm._v(_vm._s(_vm.detail.goodsUnit)),
                          ]),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-row",
                { attrs: { gutter: 20 } },
                [
                  _c(
                    "el-col",
                    { attrs: { xs: 24, sm: 12, md: 8 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "商品图片", prop: "cover" } },
                        [
                          _c("el-image", {
                            attrs: { src: _vm.detail.cover, lazy: "" },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { xs: 24, sm: 12, md: 16 } },
                    [
                      _c("el-form-item", { attrs: { label: "商品轮播图" } }, [
                        _c(
                          "div",
                          { staticClass: "image-list" },
                          _vm._l(_vm.detail.galleries, function (item, index) {
                            return _c("el-image", {
                              key: index,
                              attrs: { src: item, lazy: "" },
                            })
                          }),
                          1
                        ),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-collapse-item",
            { attrs: { title: "商品价格", name: "Prices" } },
            [
              _c(
                "el-row",
                { attrs: { gutter: 20 } },
                [
                  _c(
                    "el-col",
                    { attrs: { xs: 24, sm: 12, md: 8 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          staticClass: "inline-form-item",
                          attrs: { label: "供货价" },
                        },
                        [
                          _c("span", { staticClass: "el-input max-width" }, [
                            _vm._v(_vm._s(_vm.detail.stockPrice)),
                          ]),
                          _c(
                            "el-tooltip",
                            {
                              attrs: {
                                effect: "light",
                                content: "供货价包含了快递费用等",
                                placement: "right",
                              },
                            },
                            [
                              _c("i", {
                                staticClass: "el-icon-warning-outline",
                              }),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { xs: 24, sm: 12, md: 8 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          staticClass: "inline-form-item",
                          attrs: { label: "建议售价" },
                        },
                        [
                          _c("span", { staticClass: "el-input max-width" }, [
                            _vm._v(_vm._s(_vm.detail.retailPrice)),
                          ]),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-collapse-item",
            { attrs: { title: "商品介绍", name: "Introduction" } },
            [
              _c(
                "el-row",
                { attrs: { gutter: 20 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c("el-form-item", [
                        _c("div", {
                          staticClass: "my-editor",
                          domProps: { innerHTML: _vm._s(_vm.detail.intro) },
                        }),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }